import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoggedInGuard } from '../../authentication/logged-in-guard.service';
import { LoggedOutGuard } from '../../authentication/logged-out-guard.service';
import { AuthService }    from '../../authentication/auth.service';
import {FinanceService} from './finance.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ListProposalsComponent } from './list-proposals/list-proposals.component';
import { ListBoqsComponent } from './list-boqs/list-boqs.component';
const routes: Routes = [
  {
      path: '',
      canActivate: [LoggedInGuard],
      component: DashboardComponent
  },
  {
  	path: 'project/:id/list-proposals',
      canActivate: [LoggedInGuard],
      component: ListProposalsComponent
  },
  {
  	path: 'project/:id/list-boqs',
      canActivate: [LoggedInGuard],
      component: ListBoqsComponent
  }
    
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [FinanceService]
})
export class FinanceRoutingModule { }



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/finance/finance-routing.module.ts